/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ModelCommonResponse, ModelEditColumnRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EditColumn<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description edit column
   *
   * @tags table
   * @name EditColumnCreate
   * @summary edit column
   * @request POST:/editColumn
   */
  editColumnCreate = (
    request: ModelEditColumnRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/editColumn`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
